export const OutLinks = {
	verification_service: 'https://lkk.esphere.ru/registration/#/6',
	bank_guarantee: `https://login.sberbank-ast.ru/Login.aspx?
	ReturnUrl=%2f%3fwa%3dwsignin1.0%26wtrealm%3dhttp%253a%252f%
	252fwww.sberbank-ast.ru%252f%26wreply%3daHR0cDovL3d3dy5zYmVyYmFuay1hc3QucnUvdHJhZGV6b25lL2RlZmF1bHQuYXNweA%253d%253d&
	wa=wsignin1.0&wtrealm=http%3a%2f%2fwww.sberbank-ast.ru%2f&
	wreply=aHR0cDovL3d3dy5zYmVyYmFuay1hc3QucnUvdHJhZGV6b25lL2RlZmF1bHQuYXNweA%3d%3d`,
	getIp: 'https://api.ipify.org',
	daData: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/iplocate/address?ip=:ip',
	sberIsClient: `https://sbi.sberbank.ru:9443/ic/dcb/index.html#/credits/credit-financing?
	lightbox=lightbox/credit-financing/products&partnerCode=dasredaclientnew`,
	sberNoClient: `https://sbi.sberbank.ru:9443/ic/dcb/login.html#/register?ReturnTo=/guest-area/org-register
		&BackUrl=https%3A%2F%2Fsbi.sberbank.ru%3A9443%2Fic%2Fdcb%2Findex.html%23%2Fguest-area
		&partnerCode=dasredaneclonlinemain&productCode=CreditMMB`,
	cabinetPoll: 'https://partners.dasreda.ru/knowledge/oprosy/vnesenie-izmeneniy-v-ip-ooo',
	sberIsClientLandingBussines:
		'https://sbi.sberbank.ru:9443/ic/dcb/index.html#/credits/credit-financing/partner-code/dasredacbc/corporate-cards',
	sberNoClientLandingBussines: `https://sbi.sberbank.ru:9443/ic/dcb/login.html#/register
		?ReturnTo=/guest-area/org-register
		&BackUrl=https%3A%2F%2Fsbi.sberbank.ru%3A9443%2Fic%2Fdcb%2Findex.html%23%2Fguest-area
		&partnerCode=dasredaneclcbc&productCode=CreditMMB`,
	product_doc_doc: 'https://lk.sberhealth.ru/checkout/mmb/151',
	product_moya_buhgalteriya_autsorsing: 'https://sber-solutions.ru/for-delovaya_sreda',
	product_sberegi_biznes:
		'https://online.sberbankins.ru/store/mmb/savebusiness/?partner=dasreda&inn=:inn',
	product_sberegi_biznes_test:
		'https://dev.sberbankins.ru/mmb/savebusiness-test/?partner=dasreda&inn=:inn',
	product_double_gis: 'https://sber.2gis.ru/ds',
	instructionProCabinet:
		'https://partners.dasreda.ru/knowledge/neo/razdel-kabinet-registratora-pro',
	accreditation: 'https://partners.dasreda.ru/knowledge/neo/rbo-access',
	effectiveSales: 'https://partners.dasreda.ru/knowledge/neo/dashboard',
	postback: {
		'7703387266': `https://cpaex.scaletrk.com/track/goal-by-click-id?goal_id=3627
		&click_id=:click_id&track_id=:track_id`,
	},

	pixel_rko: {
		path: 'https://bankiru.go2cloud.org/SLgH?adv_sub=:id',
		partner_id: 'bdf95d3aafdae81607dd',
		path_leads:
			'http://api.leads.su/advertiser/conversion/createUpdate' +
			'?token=70efcc0f048e2c80dea43bc88ba74e6c&goal_id=0&status=pending' +
			'&transaction_id=:transactionId&adv_sub=:partnerRequestId',
	},
	pixel_workle: 'https://www.workle.ru/request/:partnerId/questionnaire/filled/:partnerRequestId',
	broker: {
		anketa: '/bg_anketa.xlsx',
		download_template_agreement: '/public/bg_pd_agreement_template.pdf',
		offer: 'https://partners.dasreda.ru/knowledge/conditions/public-offer',
		attorney_template: '/bg_pd_attorney_template.doc',
	},
	referenceSales: 'https://partners.dasreda.ru/knowledge/neo/dashboard',
	referenceLead: 'https://partners.dasreda.ru/knowledge/neo/lead_pro',
	tariffsSber: 'http://www.sberbank.ru/ru/s_m_business/bankingservice/acquiring_total',
	insales: 'https://www.insales.ru/page/dasreda?dasreda_account[sber_inn]=:inn',
	businessapps: 'http://www.sberbank.ru/ru/s_m_business/businessapps',
	knowledge_dos_ip: 'https://partners.dasreda.ru/knowledge/rbidos/dos-ip',
	payment_pay_link: 'https://partners.dasreda.ru/knowledge/neo/razdel-kabinet-registratora-pro',
	sber_open_card_offices: 'https://www.sberbank.ru/ru/oib?tab=vsp&segment=lp',
	dos_ip: 'https://sbi.sberbank.ru:9443/ic/dcb/#/register?ReturnTo=/ufs/remote-open-acc-two/dos',
	partner_personal_account: {
		help: 'https://www.sberbank.ru/help/business/sbbol/100105',
		sms: 'https://www.sberbank.com/sms/smallbusiness?source=account',
		knowledge_dos_ip:
			'https://partners.dasreda.ru/knowledge/otkrytie-scheta/distantsionnoe-otkrytie-scheta-ip-ooo-cherez-sayt',
		knowledge_dos_ip_cherez_sbol:
			'https://partners.dasreda.ru/knowledge/otkrytie-scheta/dos-ip-sbol',
		request_manager: 'https://s.sber.ru/1VP8RH',
		office_addresses: 'https://www.sberbank.com/ru/oib?tab=vsp&segment=lp&lps2',
	},
	cost_calculator: 'https://patent.nalog.ru/info/',
	cookie_policy:
		'https://cdn.dasreda.ru/storage-data/850d2322-fe52-45f7-b3ba-8e08f9a9bde0/politika_ispol-zovaniya_cookies.pdf',
	knowledge_clients_docs_check:
		'https://partners.dasreda.ru/knowledge/rbidos/dopolnitelnaya-proverka-dannyh-klienta',
	sber_prime: 'https://www.sberbank.com/ru/s_m_business/open-accounts/prime',
	sber_online: 'https://s.sber.ru/Lmz6RW',
	address_sber_online: 'https://www.sberbank.com/ru/oib?tab=vsp&segment=lp&lps2',
	otkrytie_scheta: 'https://partners.dasreda.ru/knowledge/otkrytie-scheta/dos-ip-sbol',
}
